<template>
    <modal dialog="modal-lg" class="dark-top" :footer="true">
        <div slot="title">
            <h2>Terms of Service & Privacy Policy</h2>
        </div>
        <div slot="body">

            <div class="col-sm-12 mt-2 d-flex justify-content-end" style="margin-bottom: -1.5rem;">
                <div class="langPicker">
                    <v-select :options="languagesAvailable" v-model="selectedLanguage"></v-select>
                </div>
            </div>

            <span :is="selectedLanguage.lang"></span>
        </div>

        <div slot="footer" class="d-flex align-items-center justify-content-between">
            <button type="button" class="btn cancel wider mr-3" @click="close">Ok</button>
        </div>
    </modal>
</template>

<script>
    import Modal from './Modal'
    import extendedVSelect from '@/extends/vue-select'
    import { mapActions, mapGetters } from 'vuex'

    import conditionsPt from '../../components/other/conditions/Conditions_pt'
    import conditionsEn from '../../components/other/conditions/Conditions_en'
    export default {
        data: function() {
            return {
                languagesAvailable:[
                    {id:1, label:"English", lang:"conditions-en"},
                    {id:2, label:"Portuguese", lang:"conditions-pt"},
                ],
                selectedLanguage: null
            }
        },
        created: function() {
            this.selectedLanguage = this.languagesAvailable[0]
        },
        methods: {
            ...mapActions([
                'closeModal',
            ]),
            close: function() {
                this.closeModal();
            },
        },
        components: {
            Modal,
            vSelect: extendedVSelect,
            conditionsPt,
            conditionsEn,
        }
    }
</script>

<style lang="scss" scoped>
    .langPicker{
        width: 250px;
    }
</style>



// WEBPACK FOOTER //
// TosConditions.vue?566467d6